<template>
  <div class="parkingPay">

  </div>
</template>

<script>
import { mySessionStorage } from '@/utils/storage.js'
export default {
  name: "queryOrder",
  data() {
    return {
      title: "",
      active: "2",
      carNum: "",
      openid:"",
      adsenceImgUrl:"../static/img/adsence4.jpg",
      
    };
  },
  methods: {
    onClickLeft() {
      console.log("返回");
      this.$router.push("/menu");
    },

    getcarNum(carNum){
      console.log(carNum);
      this.carNum=carNum;
    },
    //跳转到未绑定车牌缴费页面
    goToqueryOrder(){
      this.$router.push("queryOrder" );
    },
    //根据openid查询是否有绑定车牌
    getBindCar(){
      let params = {
        openid: this.openid,
      };
      this.$http
        .post(this.$api.queryBindCar, params)
        .then(res => {
          console.log("车牌信息:", res);
          console.log("车牌信息:", res.data.length);
          if (res.data.length>0) {
            //跳转到carNumOrder页面
            this.goToCarNumOrder(res.data);
          }
          else{
            this.goToqueryOrder();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //跳转到carNumOrder页面
    goToCarNumOrder(carNumList){
      this.$router.push(
        {
          name:"carNumOrder",
          query:{
            carNumList:carNumList
          }
        }
      );
    },
    //获取openid
    getopenId() {
      if (mySessionStorage.getItem("openid") != null && mySessionStorage.getItem("openid") != "" && mySessionStorage.getItem("openid") != "") {
        this.openid = mySessionStorage.getItem("openid");
        this.getBindCar();
      } else {
        this.$getOpenid().then(res => {
          this.openid = mySessionStorage.getItem("openid");
          console.log("--------------------------", this.openid);
          this.getBindCar();
        });

      }
    }

    
  },
  created() {
    

  },
  mounted(){
    this.getopenId();
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/parkingPay.vue